import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { MaintainAspectRatio } from '@frontend/web/components/MaintainAspectRatio';
import { css } from 'emotion';
import { textSans } from '@guardian/src-foundations/typography';
const titleStyle = css `
	p {
		${textSans.large()};
		font-weight: bold;
	}
`;
export const VineBlockComponent = ({ element }) => {
    return (_jsx(_Fragment, { children: element.url && element.width && element.height && (_jsxs("div", { children: [_jsx("div", Object.assign({ className: titleStyle }, { children: _jsx("p", { children: element.title }, void 0) }), void 0),
                _jsx(MaintainAspectRatio, Object.assign({ height: element.height, width: element.width }, { children: _jsxs("div", Object.assign({ className: "element-vine" }, { children: [_jsx("iframe", { title: "vine-embed", src: element.url, height: element.height, width: element.width }, void 0),
                            _jsx("script", { async: true, src: "https://platform.vine.co/static/scripts/embed.js" }, void 0)] }), void 0) }), void 0)] }, void 0)) }, void 0));
};
